export const PRODUCT_TYPE = {
  DEVICE: 'device',
  MOBILE_SUBSCRIPTION: 'mobilesubscription',
  ACCESSORY: 'accessory',
  MOBILE_BROADBAND_SUBSCRIPTION: 'mobilebroadbandsubscription',
  MOBILE_BROADBAND_HARDWARE: 'mobilebroadbandhardware'
}
